"use client";

import React, {useEffect, useState} from "react";
import {Button} from "@/shared/components/ui/button";

const setCookiesConsent = ()=> {
    document.cookie = 'formula-autogarantcity-metrica-consent=1; max-age=31536000; samesite=lax; path=/';
};

const checkCookiesConsent = (): boolean => {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    return cookies.includes('formula-autogarantcity-metrica-consent=1');
};

export const AcceptCookies: React.FC = () => {
    const [isShown, setIsShown] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true); // Изначально свернуто

    useEffect(() => {
        setIsShown(checkCookiesConsent());
    }, []);

    const handleAccept = (): void => {
        setCookiesConsent();
        setIsShown(true);
    };

    const toggleCollapse = (): void => {
        setIsCollapsed(!isCollapsed);
    };

    if (isShown) return null;

    return (
        <div className="fixed left-0 bottom-0 z-50 w-full">
            <div className="bg-custom-black rounded-t-2xl shadow-2xl max-w-full w-full mx-auto transition-all duration-300">
                {isCollapsed ? (
                    // Свернутая версия - показываем основную информацию и кнопку
                    <div className="p-3 md:p-4">
                        <div className="flex items-start justify-between gap-3 mb-3">
                            <div className="flex items-center space-x-3">
                                <div className="w-8 h-8 bg-custom-light-orange rounded-lg flex items-center justify-center flex-shrink-0">
                                    <svg className="w-4 h-4 text-custom-orange" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd"
                                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                              clipRule="evenodd"/>
                                    </svg>
                                </div>
                                <h3 className="text-xs font-bold uppercase text-custom-orange">
                                    Файлы cookie
                                </h3>
                            </div>
                            <button 
                                onClick={toggleCollapse}
                                className="text-white hover:text-custom-orange transition-colors p-1 flex-shrink-0" 
                                aria-label="Развернуть"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                </svg>
                            </button>
                        </div>
                        <div className="mb-3">
                            <p className="text-xs text-white leading-relaxed font-bold uppercase">
                                Оставаясь на сайте, вы соглашаетесь с обработкой данных в указанных целях.
                            </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3">
                            <Button variant={'filledOrange'} className="lg:text-[12px] flex-1 px-1 py-1 font-button" onClick={handleAccept}>
                                Принять
                            </Button>
                        </div>
                    </div>
                ) : (
                    // Развернутая версия
                    <div className="p-2 md:p-4">
                        <div className="flex items-start justify-between mb-2">
                            <div className="flex items-center space-x-3">
                                <div className="w-8 h-8 bg-custom-light-orange rounded-lg flex items-center justify-center">
                                    <svg className="w-4 h-4 text-custom-orange" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd"
                                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                              clipRule="evenodd"/>
                                    </svg>
                                </div>
                                <h3 className="text-xs font-bold uppercase text-custom-orange">
                                    Файлы cookie
                                </h3>
                            </div>
                            <button 
                                onClick={toggleCollapse}
                                className="text-white hover:text-custom-orange transition-colors p-1 ml-2" 
                                aria-label="Свернуть"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                        </div>
                        <div className="mb-3">
                            <p className="text-xs text-white leading-relaxed">
                                Этот сайт использует сервис веб-аналитики Яндекс Метрика, предоставляемый компанией ООО «ЯНДЕКС», 119021, Россия, Москва, ул. Л. Толстого, 16 для анализа пользовательской активности через «cookie».
                                Информация, собранная посредством cookie, не идентифицирует вас, но помогает улучшить сайт.
                                Данные передаются и хранятся на сервере Яндекса в РФ и/или ЕЭЗ для оценки использования вами сайта, составления отчетов об активности на сайте.
                                Вы можете отказаться от использования cookie через настройки браузера или перейдя по {' '}
                                <a className="text-text-custom-light-orange hover:text-custom-light-orange underline transition-colors" href={'https://yandex.ru/support/metrika/general/opt-out.html'} target={'_blank'}>ссылке</a>.
                            </p>
                            <p className="text-xs text-white leading-relaxed font-bold uppercase">Оставаясь на сайте, вы соглашаетесь с обработкой данных в указанных целях.</p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3">
                            <Button variant={'filledOrange'} className="lg:text-[12px] flex-1 px-1 py-1 font-button" onClick={handleAccept}>
                                Принять
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
